import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "67",
  height: "67",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M33.1 11.1c10.041 0 18.399 7.145 20.275 16.661 7.171.497 12.826 6.4 12.826 13.682 0 7.613-6.179 13.792-13.792 13.792H16.55C7.42 55.235 0 47.815 0 38.685c0-8.524 6.455-15.558 14.757-16.44C18.205 15.624 25.13 11.1 33.101 11.1Zm5.517 35.86V35.925h8.276L33.1 22.134 19.309 35.926h8.275v11.033h11.033Z",
      fill: "#1254A6"
    }, null, -1)
  ]))]))
}
export default { render };